import strings from '../../globalization';
import consts from '../../consts';

const minMaxValidator = (min, max) => value =>
  value && (value.length > max || value.length < min)
    ? `Must be more than ${min} and less than ${max} characters`
    : undefined;
const minLength = len => value =>
  value && value.length < len ? `Must be ${len} characters` : undefined;

const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const alphaNumeric = /^[a-zA-Z0-9_-]*$/;
const accessUrl = /(?:(file:\/\/([\w].*):\/)([A-Za-z].+))|(?:(http|https):\/\/([\w].*)(:|\/)([0-9]{0,5}))|(\\[a-z_\-\s0-9\.]+)+/;
const specialChar = /[`!@#$%^&*_+\=\[\]{};':"\\|,.<>\/?~]/;
export default {
  required: value => (!value || value.length === 0) && 'Required',
  email: value =>
    value &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) &&
    strings.InvalidEmail,
  passwordStrength: value =>
    value &&
    value !== consts.FakePassword &&
    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#/$%/^&/*]).{8,50}$/.test(
      value
    ) &&
    strings.PasswordValidationError,
  confirmPassword: (value, formData) => {
    return (formData.Password || formData.NewPassword) !== value
      ? 'Password Mismatch'
      : undefined;
  },
  minLength2: minLength(2),
  minMaxValidator220: minMaxValidator(2, 20),
  minMaxValidator264: minMaxValidator(2, 64),
  clientCN: value =>
    !/^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/.test(value) &&
    'Invalid Mac Address',
  serverCN: value => !/[a-zA-Z]{2,50}/.test(value) && 'Invalid Machine Name',
  onlyAlphabetsAllowed: value =>
    !/^[a-zA-Z]+$/.test(value) && 'Only alphabets are allowed',
  guidValidation: value =>
    value
      ? !guidPattern.test(value) && 'Please enter a valid machine key'
      : null,
  alphaNumeric: value =>
    !alphaNumeric.test(value) && 'Please enter a valid Serial Number',
  accessUrl: value =>
    value && !accessUrl.test(value) && 'Please enter a valid Access URL',
  hasSpecialChar: value => {
    return (
      value && specialChar.test(value) && 'Special characters are not allowed'
    );
  }
};
